import { Menu, Bell, ChevronDown, LogOut } from 'lucide-react';
import { Button } from '@/ui/button';
import { Avatar, AvatarFallback, AvatarImage } from '@/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/ui/dropdown-menu';
import { useAdminAuth } from '@/hooks/useAdminAuth';

interface AdminHeaderProps {
  onToggleSidebar?: () => void;
}

export function AdminHeader({ onToggleSidebar }: AdminHeaderProps) {
  const { adminUser, adminLogout } = useAdminAuth();

  const handleLogout = async () => {
    try {
      await adminLogout();
    } catch (error) {
      console.error('管理员退出登录失败:', error);
    }
  };

  return (
    <header className="flex items-center justify-between h-16 bg-white rounded-xl border border-[#E5E7EB] shadow-sm px-6">
      {/* 左侧 - 侧边栏切换按钮 */}
      <div className="flex items-center">
        <Button
          variant="ghost"
          size="sm"
          onClick={onToggleSidebar}
          className="lg:hidden mr-4"
        >
          <Menu className="h-5 w-5" />
        </Button>
        <div>
          <h1 className="text-lg font-semibold text-gray-900">管理后台</h1>
          <p className="text-xs text-gray-500">WhaleHire Admin System</p>
        </div>
      </div>

      {/* 右侧 - 用户信息和操作 */}
      <div className="flex items-center gap-4">
        {/* 通知铃铛 */}
        <Button variant="ghost" size="sm" className="relative">
          <Bell className="h-5 w-5" />
          {/* 可以在这里添加未读消息数量角标 */}
          <span className="absolute -top-1 -right-1 h-2 w-2 bg-red-500 rounded-full"></span>
        </Button>

        {/* 用户信息下拉菜单 */}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              className="flex items-center gap-2 p-2 h-auto hover:bg-gray-50"
            >
              <Avatar className="h-8 w-8">
                <AvatarImage
                  src={adminUser?.avatar_url}
                  alt={adminUser?.username}
                />
                <AvatarFallback className="bg-gradient-to-r from-blue-500 to-cyan-600 text-white text-sm font-medium">
                  {adminUser?.username?.charAt(0)?.toUpperCase() || 'A'}
                </AvatarFallback>
              </Avatar>
              <div className="flex flex-col items-start">
                <span className="text-sm font-medium text-gray-900">
                  {adminUser?.username || '管理员'}
                </span>
                <span className="text-xs text-gray-500">
                  {adminUser?.account ||
                    adminUser?.email ||
                    'admin@whalehire.com'}
                </span>
              </div>
              <ChevronDown className="h-4 w-4 text-gray-500" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56">
            <DropdownMenuItem className="cursor-pointer" onClick={handleLogout}>
              <LogOut className="mr-2 h-4 w-4" />
              <span>退出登录</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}
